import { apiClient } from './api';
import { MultiBlogRequest, MultiBlogResponse } from '../models/blog';

export class BlogService {
  static async generateBlogPost(request: MultiBlogRequest): Promise<MultiBlogResponse> {
    const response = await apiClient.post('/api/multi-agent/blog/start', request);
    return response.data;
  }
}

export default BlogService;